import { BaseResourceApiService } from '@shared/services/BaseResourceApiService';
import { HLR_URL } from '@shared/helpers/env';
// import axios from 'axios';

class HLRServiceClass extends BaseResourceApiService {
  constructor(opts) {
    super(opts);
  }

  getList(params) {
    return this.http.get('', { params: params });
  }

  upload(file) {
    return this.http.post('/upload', file);
  }

  download(id, destination) {
    return this.full_response_http.get(`/${id}/export/${destination}/download-by-hash`);
  }
}

export const HLRService = new HLRServiceClass({
  api_version: 1,
  base_url: HLR_URL,
  resource: 'tasks'
});
